import React from "react"

export default class Footer extends React.Component {
  render() {
    return (
      <div className="footer py-4 d-flex flex-lg-column" id="kt_footer">
        <div className="container-fluid d-flex flex-column flex-md-row align-items-center justify-content-between">
          <div className="text-dark order-2 order-md-1">
            <span className="text-muted font-weight-bold mr-2">&copy;	{new Date().getFullYear()}</span>
            <a href={window.General.WebsiteUrl} target="_blank" className="text-dark-75 text-hover-primary"> Linkie</a>
          </div>
          <ul className="menu menu-gray-600 menu-hover-primary fw-bold order-1">

          </ul>
        </div>
      </div>
    )
  }
}